 import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {BrowserModule, Meta} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {AdminCoreModule} from "./admin-core/admin-core.module";
import {SharedModule} from "./shared/shared.module";
import {NotifyHostComponent} from "./shared/notify/notify-host.component";
import {CommonModule} from "@angular/common";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {NgbModal, NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {FocusSafeNgbModal} from "./admin-core/services";
import {IMaskModule} from "angular-imask";
import { DndModule } from 'ngx-drag-drop';
import { RouteReuseStrategy } from '@angular/router';
import { AiChatWidgetComponent } from './ai-chat-widget/ai-chat-widget.component';
import { provideHighcharts } from 'highcharts-angular';

@NgModule({
  declarations: [
    AppComponent,
  ],

  imports: [
     BrowserModule,
    AppRoutingModule,
    AdminCoreModule,
    CommonModule,
    BrowserAnimationsModule,
     NgbModule,
    IMaskModule,
    SharedModule,
    DndModule,
    AiChatWidgetComponent,
    NotifyHostComponent,
    // AngularFireMessagingModule
    // AngularFireModule.initializeApp(environment.firebase),
],
  providers: [
    Meta,
    // highcharts-angular v5 loads the Highcharts instance from a provider
    // (the `[Highcharts]` input was removed). HighchartsChartService is
    // providedIn:'root', so the loader MUST be registered at the root injector —
    // a lazy feature module's provider is in a child injector the root service
    // can't see (→ NG0201). No extra modules: the chart download feature was
    // removed, and loading the exporting modules here intermittently threw
    // "Failed to load Highcharts modules".
    provideHighcharts(),
  ],
  bootstrap: [AppComponent],
  exports: [],
  schemas: [NO_ERRORS_SCHEMA]
})
export class AppModule {
}
